import { linesConfigGlobal, setBetValueGlobal } from "../config/GlobalVariableConfig";

// import { spinResponseDataGlobal } from "../config/GlobalVariableConfig";

import { REEL_NUMBERS } from "../config/reelConfig";
import { customSortColumnWise, getCoordinates } from "../core/utils";
import { GameConstants } from "../gameClientEvents/GameConstants";
const numberUnit = 0.01; // in cents
const CASH_MULT = 0.1;

export interface WinObject { // the object -how we want to use in our program 
    lineId: number | null;
    count: number;
    symbolId: number;
    winAmount: number;
    winSymbolPosistions: number[][] | null;
    winMultiplier: number;
    bonusWon: string;
}

export interface IActivatedSymbols {
    positions: number[][];
    progress: number;
    validSymbols?: number[];
}

export interface IRIP {
    name: string
}

export interface IReinfest extends IRIP {
    multipliers: number[];
    pickedPositions: number[][];
    postMult: number[][];
}

export interface IReplicate extends IRIP {
    postMult: number[][];
}

export interface ICoinWin extends IRIP {
    positions: number[][];
    win: number;
}

export interface IReawaken extends IRIP {
    multipliers: number[][];
}

export interface IRIPFeature {
    initialMultipliersSymbolIds: number[][];
    ripPos: number[][];
    data: IRIP[];
}

export interface IFeatureData {
    featureName: string;
    activatedSymbols?: IActivatedSymbols;
    fortuneMeter?: number;
    meterPrevValue?: number;
    meterNewValue?: number;
    feature?: IRIPFeature;
}

export interface RespinObject { // the object -how we want to use in our program 

    type: string;
    freeGameTrigger: number;
    reelSymbols: number[][];
    winLines: WinObject[] | null; // Making winLines optional because might be no win
    winScatters: WinObject[] | null;
    winAmount: number; // win of that particular cascade respin 
    multiplier: number; // accumulated multiplier applicable on  that particular respin 
    accumulatedsWinAmount: number; // win of that particular respin total
    cascadePositions: number[][];
    featureData: IFeatureData;
}

export interface SpinDataObject { // the object -how we want to use in our program 

    dataFeatched: boolean;

    betAmount: number;

    // state value - kind of header
    freeGameTrigger: number; // number of fs won in base game
    freeGameReTrigger: number;  // number of fs won in free game
    totalFreeGame: number; // total number of fs - to show in counter 
    remainingFreeGame: number; // remaining number of fs - to show in counter 
    totalAccumulatedWin: number; // used specially in free games
    totalWin: number;  // win of current spin including all respins
    balance: number;
    isWinHigherBet: boolean;

    respins: RespinObject[];

};



export const spinData: SpinDataObject = { // use in other class

    dataFeatched: false,

    betAmount: 0,
    freeGameTrigger: 0,
    freeGameReTrigger: 0,
    totalFreeGame: 0,
    remainingFreeGame: 0,
    totalAccumulatedWin: 0,
    totalWin: 0,
    balance: 0,
    isWinHigherBet: false,
    respins: []
};

export function resetSpinData(): void {
    spinData.dataFeatched = false;

    spinData.freeGameTrigger = 0;
    spinData.freeGameReTrigger = 0;
    spinData.totalFreeGame = 0;
    spinData.remainingFreeGame = 0;
    spinData.totalAccumulatedWin = 0;
    spinData.totalWin = 0;
    spinData.balance = 0;
    spinData.isWinHigherBet = false;

    spinData.respins = [];
}


export function parserSpinResponse(data: any): void {
    console.log("inside parserSpinResponse", data);

    // Initialize the SpinDataObject
    spinData.dataFeatched = true;

    spinData.betAmount = Number(data.betAmountString) / 100;
    setBetValueGlobal(spinData.betAmount);

    if (Number(data.latestWinString) > Number(data.betAmountString)) {
        spinData.isWinHigherBet = true;
    } else {
        spinData.isWinHigherBet = false;
    }

    let preReelsymbols: number[][] = [];

    data.events.forEach((event: any) => {

        // Each spin will be treated as a respin
        let reelSymbols: number[][] = (event.c && event.c.grid) ? decodeGrid(event.c.grid) : [];
        // console.log(reelSymbols);
        let respinWinAmount = Number((event.wa * numberUnit).toFixed(2)); // Total win of that particular respin
        // console.log(winAmount);

        let accumWinAmount = Number((event.awa * numberUnit).toFixed(2)); // Total win of that particular respin

        let totalMultiplier = 1;

        const type = event.etn;

        // // Check for feature spin (e.g., free game trigger)
        let freeGameTrigger = 0;
        if (event.etn === "feature_enter") {
            freeGameTrigger = Number(event.c.bonusFeatureCount) || 0;
            spinData.freeGameTrigger = Number(event.c.bonusFeatureCount) || 0;
            spinData.totalFreeGame = Number(event.c.bonusFeatureCount) || 0;
        }

        const winLines: WinObject[] = [];
        const winScatters: WinObject[] = [];
        const cascadePositions: number[][] = [];
        let featureData: IFeatureData;
        featureData = {
            featureName: "",
            fortuneMeter: 0,
            activatedSymbols: {
                positions: [],
                progress: 0
            },
            feature: {
                initialMultipliersSymbolIds: [],
                data: [],
                ripPos: []
            }
        }

        event.c && event.c.actions?.forEach((action: any) => {
            if (action.at === "fortuneMeter") {
                featureData.featureName = action.data.at;
                featureData.fortuneMeter = Number(action.data.v);
            } else if (action.at === "bonusfeaturewon") {
                featureData.fortuneMeter = Number(action.data.fortuneMeterStartCount);
            } else if (action.at === "bonusFortuneMeter") {
                featureData.meterPrevValue = Number(action.data.preValue);
                featureData.meterNewValue = Number(action.data.newValue);
                featureData.fortuneMeter = Number(action.data.newValue);
            } else if (action.at === "activatedSymbols") {
                preReelsymbols = reelSymbols.map(row => [...row]);
                featureData.featureName = action.data.at;
                featureData.activatedSymbols.progress = Number(action.data.validSymbols.length);
                featureData.activatedSymbols.positions = getPositionsFromMask(action.data.h);
            } else if (action.at === "bonusActivatedSymbols") {
                preReelsymbols = reelSymbols.map(row => [...row]);
                featureData.activatedSymbols.positions = getPositionsFromMask(action.data.h);
                featureData.activatedSymbols.validSymbols = action.data.validSymbols.map(Number);
            } else if (action.at === "ripType") {
                featureData.featureName = action.data.v;
                featureData.feature.initialMultipliersSymbolIds = reelSymbols;
            } else if (action.at === "replicate") {
                let ripData: IReplicate = {
                    name: action.at,
                    postMult: getMultipliersIn2DPositions(action.data.postDouble)
                };
                featureData.feature.ripPos = [[getCoordinates(action.data.p).col, getCoordinates(action.data.p).row]];
                featureData.feature.data.push(ripData);
            } else if (action.at === "reawaken") {
                let ripData: IReawaken = {
                    name: action.at,
                    multipliers: decodeGrid(action.data.g)
                };
                featureData.feature.ripPos = [[getCoordinates(action.data.p).col, getCoordinates(action.data.p).row]];
                featureData.feature.data.push(ripData);
            } else if (action.at === "coinWin") {
                let ripData: ICoinWin = {
                    name: action.at,
                    win: Number(action.data.w) * numberUnit,
                    positions: getPositionsFromMask(action.data.h)
                };
                featureData.feature.data.push(ripData);
                featureData.feature.initialMultipliersSymbolIds = reelSymbols;
            } else if (action.at === "reinfest") {
                let ripData: IReinfest = {
                    name: action.at,
                    multipliers: action.data.m.map(Number),
                    pickedPositions: getValueBasedCoordinates(action.data.pickedPositions),
                    postMult: getMultipliersIn2DPositions(action.data.postMult)
                };
                featureData.feature.ripPos = [[getCoordinates(action.data.p).col, getCoordinates(action.data.p).row]];
                featureData.feature.data.push(ripData);
            } else if (action.at === "retrigger") {
                freeGameTrigger = Number(action.data.s);
            }
            else if (action.at === "gridwin") { // Handling win lines or win scatters
                const symbolId = Number(action.data.symbol);

                const winAmount = Number(action.data.winAmount * numberUnit);
                const winSymbolPositions = action.data.mask ? getReelPositions(action.data.mask) : [];
                const winMultiplier = action.data.winMultipliers ? Number(action.data.winMultipliers[0]) : 1;
                const bonusWon = action.data.bonusWon || ""; // Assuming you want to track bonus wins
                const count = Number(action.data.count)

                const lineId = getLineId(winSymbolPositions, count);


                const winObject: WinObject = {
                    lineId,
                    count,
                    symbolId,
                    winAmount,
                    winSymbolPosistions: winSymbolPositions.length > 0 ? winSymbolPositions : null,
                    winMultiplier,
                    bonusWon
                };

                if (symbolId === GameConstants.SCATTER_SYMBOL_ID) { // Assuming symbol is a scatter
                    winScatters.push(winObject);
                } else {
                    winLines.push(winObject);
                }
            }
            else if (action.at === "remove") { // Handling wild multiplier

                action.data.mask ? getReelPositions(action.data.mask) : [];
                const mask = action.data.mask; // Mask as string of 0s and 1s

                if (mask.length > 0) {
                    for (let i = 0; i < mask.length; i++) {
                        if (mask[i] === '1') { // Only process positions marked as '1'
                            const position: [number, number] = [
                                i % REEL_NUMBERS,               // Reel Number
                                Math.floor(i / REEL_NUMBERS)    // Position
                            ];
                            cascadePositions.push(position);
                        }
                    }
                }
            }

        });

        if (event.etn.includes("rip_activated")) {
            // reelSymbols.forEach((row, rowIndex) => {
            //     row.forEach((symbol, colIndex) => {
            //         if (symbol === -1) {
            //             reelSymbols[rowIndex][colIndex] = preReelsymbols[rowIndex][colIndex];
            //         }
            //     });
            // });
            reelSymbols = preReelsymbols.map(row => [...row]);
        }

        // Create the RespinObject and push it to spinData.respins
        const respin: RespinObject = {
            type: type,
            freeGameTrigger: freeGameTrigger,
            reelSymbols: reelSymbols,
            winLines: winLines.length > 0 ? winLines : null,
            winScatters: winScatters.length > 0 ? winScatters : null,
            winAmount: respinWinAmount,
            cascadePositions: cascadePositions,
            multiplier: totalMultiplier,
            accumulatedsWinAmount: accumWinAmount,
            featureData: featureData
        };

        spinData.respins.push(respin);


    });

    console.log("Parsed spin data:", spinData);

}


function decodeGrid(grid: string): number[][] {
    const offset = 40; // ASCII offset for encoding

    // Extract width and height from the first two characters
    const width = grid.charCodeAt(0) - offset;
    const height = grid.charCodeAt(1) - offset;

    // Initialize the 2D array for storing the grid
    const gridArray = [];

    // Populate the 2D array with decoded values
    let index = 2; // Start from the third character
    for (let row = 0; row < height; row++) {
        const currentRow = [];
        for (let col = 0; col < width; col++) {
            // Convert each character to its decimal value using the offset
            const cellValue = grid.charCodeAt(index) - offset;
            currentRow.push(cellValue);
            index++;
        }
        gridArray.push(currentRow);
    }


    // console.log(gridArray);

    // Transpose the 2D array (swap rows with columns)
    const transposedArray = transposeMatrix(gridArray);

    // function to transpose a matrix (2D array)
    function transposeMatrix(matrix: number[][]) {
        return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
    }

    return transposedArray;

}

function getReelPositions(binaryString: string): [number, number][] {

    // const rows = Math.ceil(binaryString.length / REEL_NUMBERS);
    const result: [number, number][] = [];

    // Loop through the binary string and fill the 2D array conceptually
    for (let i = 0; i < binaryString.length; i++) {
        const reelId = i % REEL_NUMBERS;          // Column number (reelId)
        const positionNum = Math.floor(i / REEL_NUMBERS); // Row number (position)

        if (binaryString[i] === '1') {
            result.push([reelId, positionNum]);
        }
    }

    return result;
}

function getLineId(winSymbolPositions: number[][], count: number): number | null {
    // Create an array to represent the line structure from winSymbolPositions
    const positionsByReel: number[] = [];

    for (let i = 0; i < winSymbolPositions.length; i++) {
        const [reel, pos] = winSymbolPositions[i];
        positionsByReel[reel] = pos;
    }

    // Compare with each line in linesConfigGlobal
    for (let lineIndex = 0; lineIndex < linesConfigGlobal.length; lineIndex++) {
        const lineConfig = linesConfigGlobal[lineIndex];


        let match = true;
        for (let reel = 0; reel < count; reel++) {
            if (positionsByReel[reel] !== lineConfig[reel]) {
                match = false;
                break;
            }
        }

        if (match) return lineIndex;
    }

    return null; // No match found
}

function getPositionsFromMask(mask: string) {
    let highlightPositions = [];
    if (mask.length > 0) {
        for (let i = 0; i < mask.length; i++) {
            if (mask[i] === '1') { // Only process positions marked as '1'
                const position: [number, number] = [
                    i % REEL_NUMBERS,               // Reel Number
                    Math.floor(i / REEL_NUMBERS)    // Position
                ];
                highlightPositions.push(position);
            }
        }
    }
    customSortColumnWise(highlightPositions);
    return highlightPositions;
}

function getMultipliersIn2DPositions(data: string[], columns: number = 5): number[][] {
    let arr: number[][] = [];
    for (let i = 0; i < data.length; i++) {
        const val = Number(data[i]) * CASH_MULT;
        const row = Math.floor(i / columns);
        const col = (i % columns);
        arr[col] = arr[col] || [];
        arr[col][row] = val;
    }
    return arr;
}


function getValueBasedCoordinates(data: string[], columns: number = 5): number[][] {
    return data.map((val) => {
        const numericValue = Number(val);
        const row = Math.floor(numericValue / columns);
        const col = numericValue % columns;
        return [col, row];
    });
}

